// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: odoo/asset.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "pc.proto.odoo.asset";

export interface AssetMetaV1 {
  fileName: string;
  mimeType: string;
}

export interface AssetMeta {
  meta?: { $case: "assetMetaV1"; assetMetaV1: AssetMetaV1 } | undefined;
}

export interface PlaceAssetRequest {
  fileMetaData?: AssetMeta | undefined;
}

export interface PlaceAssetResponse {
  assetKey: string;
  uploadUrl: string;
}

export interface GetAssetResponse {
  /** contains a presigned URL to s3 bucket */
  downloadUrl: string;
  fileMetaData?: AssetMeta | undefined;
}

function createBaseAssetMetaV1(): AssetMetaV1 {
  return { fileName: "", mimeType: "" };
}

export const AssetMetaV1: MessageFns<AssetMetaV1> = {
  encode(message: AssetMetaV1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    if (message.mimeType !== "") {
      writer.uint32(18).string(message.mimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssetMetaV1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetMetaV1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssetMetaV1 {
    return {
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      mimeType: isSet(object.mimeType) ? globalThis.String(object.mimeType) : "",
    };
  },

  toJSON(message: AssetMetaV1): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssetMetaV1>, I>>(base?: I): AssetMetaV1 {
    return AssetMetaV1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssetMetaV1>, I>>(object: I): AssetMetaV1 {
    const message = createBaseAssetMetaV1();
    message.fileName = object.fileName ?? "";
    message.mimeType = object.mimeType ?? "";
    return message;
  },
};

function createBaseAssetMeta(): AssetMeta {
  return { meta: undefined };
}

export const AssetMeta: MessageFns<AssetMeta> = {
  encode(message: AssetMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.meta?.$case) {
      case "assetMetaV1":
        AssetMetaV1.encode(message.meta.assetMetaV1, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssetMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.meta = { $case: "assetMetaV1", assetMetaV1: AssetMetaV1.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssetMeta {
    return {
      meta: isSet(object.assetMetaV1)
        ? { $case: "assetMetaV1", assetMetaV1: AssetMetaV1.fromJSON(object.assetMetaV1) }
        : undefined,
    };
  },

  toJSON(message: AssetMeta): unknown {
    const obj: any = {};
    if (message.meta?.$case === "assetMetaV1") {
      obj.assetMetaV1 = AssetMetaV1.toJSON(message.meta.assetMetaV1);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssetMeta>, I>>(base?: I): AssetMeta {
    return AssetMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssetMeta>, I>>(object: I): AssetMeta {
    const message = createBaseAssetMeta();
    switch (object.meta?.$case) {
      case "assetMetaV1": {
        if (object.meta?.assetMetaV1 !== undefined && object.meta?.assetMetaV1 !== null) {
          message.meta = { $case: "assetMetaV1", assetMetaV1: AssetMetaV1.fromPartial(object.meta.assetMetaV1) };
        }
        break;
      }
    }
    return message;
  },
};

function createBasePlaceAssetRequest(): PlaceAssetRequest {
  return { fileMetaData: undefined };
}

export const PlaceAssetRequest: MessageFns<PlaceAssetRequest> = {
  encode(message: PlaceAssetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileMetaData !== undefined) {
      AssetMeta.encode(message.fileMetaData, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlaceAssetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceAssetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileMetaData = AssetMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceAssetRequest {
    return { fileMetaData: isSet(object.fileMetaData) ? AssetMeta.fromJSON(object.fileMetaData) : undefined };
  },

  toJSON(message: PlaceAssetRequest): unknown {
    const obj: any = {};
    if (message.fileMetaData !== undefined) {
      obj.fileMetaData = AssetMeta.toJSON(message.fileMetaData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceAssetRequest>, I>>(base?: I): PlaceAssetRequest {
    return PlaceAssetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceAssetRequest>, I>>(object: I): PlaceAssetRequest {
    const message = createBasePlaceAssetRequest();
    message.fileMetaData = (object.fileMetaData !== undefined && object.fileMetaData !== null)
      ? AssetMeta.fromPartial(object.fileMetaData)
      : undefined;
    return message;
  },
};

function createBasePlaceAssetResponse(): PlaceAssetResponse {
  return { assetKey: "", uploadUrl: "" };
}

export const PlaceAssetResponse: MessageFns<PlaceAssetResponse> = {
  encode(message: PlaceAssetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assetKey !== "") {
      writer.uint32(10).string(message.assetKey);
    }
    if (message.uploadUrl !== "") {
      writer.uint32(18).string(message.uploadUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlaceAssetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceAssetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assetKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uploadUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceAssetResponse {
    return {
      assetKey: isSet(object.assetKey) ? globalThis.String(object.assetKey) : "",
      uploadUrl: isSet(object.uploadUrl) ? globalThis.String(object.uploadUrl) : "",
    };
  },

  toJSON(message: PlaceAssetResponse): unknown {
    const obj: any = {};
    if (message.assetKey !== "") {
      obj.assetKey = message.assetKey;
    }
    if (message.uploadUrl !== "") {
      obj.uploadUrl = message.uploadUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceAssetResponse>, I>>(base?: I): PlaceAssetResponse {
    return PlaceAssetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceAssetResponse>, I>>(object: I): PlaceAssetResponse {
    const message = createBasePlaceAssetResponse();
    message.assetKey = object.assetKey ?? "";
    message.uploadUrl = object.uploadUrl ?? "";
    return message;
  },
};

function createBaseGetAssetResponse(): GetAssetResponse {
  return { downloadUrl: "", fileMetaData: undefined };
}

export const GetAssetResponse: MessageFns<GetAssetResponse> = {
  encode(message: GetAssetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.downloadUrl !== "") {
      writer.uint32(10).string(message.downloadUrl);
    }
    if (message.fileMetaData !== undefined) {
      AssetMeta.encode(message.fileMetaData, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAssetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAssetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.downloadUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileMetaData = AssetMeta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAssetResponse {
    return {
      downloadUrl: isSet(object.downloadUrl) ? globalThis.String(object.downloadUrl) : "",
      fileMetaData: isSet(object.fileMetaData) ? AssetMeta.fromJSON(object.fileMetaData) : undefined,
    };
  },

  toJSON(message: GetAssetResponse): unknown {
    const obj: any = {};
    if (message.downloadUrl !== "") {
      obj.downloadUrl = message.downloadUrl;
    }
    if (message.fileMetaData !== undefined) {
      obj.fileMetaData = AssetMeta.toJSON(message.fileMetaData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAssetResponse>, I>>(base?: I): GetAssetResponse {
    return GetAssetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAssetResponse>, I>>(object: I): GetAssetResponse {
    const message = createBaseGetAssetResponse();
    message.downloadUrl = object.downloadUrl ?? "";
    message.fileMetaData = (object.fileMetaData !== undefined && object.fileMetaData !== null)
      ? AssetMeta.fromPartial(object.fileMetaData)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
